export default __webpack_public_path__ + "static/media/image9.1e1a5c0e.jpg";